import {
  GET_ADMIN_USER_DATA_FAILURE,
  GET_ADMIN_USER_DATA_REQUEST,
  GET_ADMIN_USER_DATA_SUCCESS,
} from './Dashboard.constant';
import {
  AdminDasboardActionTypes,
  IAdminDashboardData,
} from './Dashboard.type';

const initialState: IAdminDashboardData = {
  data: null,
  isLoading: false,
};

export default function adminDashboardReducer(
  state = initialState,
  action: AdminDasboardActionTypes,
): IAdminDashboardData {
  switch (action.type) {
    case GET_ADMIN_USER_DATA_REQUEST:
      return { ...state, isLoading: true };
    case GET_ADMIN_USER_DATA_SUCCESS:
      return { ...state, isLoading: false, data: action.payload };
    case GET_ADMIN_USER_DATA_FAILURE:
      return { ...state, isLoading: false };

    default:
      return { ...state };
  }
}
